<div class="message">{{ data.message }}</div>

<button mat-icon-button class="btn-close" (click)="dismiss()">
  <mat-icon i18n-title="common.action.close"
            title="Close">close</mat-icon>
</button>
